<script lang="ts" setup>
  import { defineComponent, onMounted, reactive } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/parceirosService";
  import {f2dec} from "@/utils/funcoes";

  //componentes
  import Paginador from "@/components/Paginador/Index.vue";
  import DropdownCidadesAtiva from "@/components/Dropdowns/DropdownCidadesAtiva.vue";
  import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";

  var controle = reactive({
    filtros: {
      comCidades: true,
      ativo: null,
      voucher: null,
      paginaAtual: 1,
      tamanhoPagina: 10
    } as unknown as service.Filtros,
    itens: [] as service.Parceiro[],
    totalRegistros: 0,

    listaStatus:[ 
      {valor: null, descricao:"- Todos -"},
      {valor: true, descricao:"Ativos"},       
      {valor: false, descricao:"Inativos"},
    ],

    listaVouchers:[ 
      {valor: null, descricao:"- Todos -"},
      {valor: true, descricao:"SIM"},       
      {valor: false, descricao:"NÃO"},
    ],

    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },
  })

  onMounted(async ()=>{
    
    pesquisar();
  })

  async function pesquisar() {

    service.obter(controle.filtros)
    .then(r=> {
      controle.itens = r.dados;
      controle.totalRegistros = r.totalRegistros;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

  function ordenarPor(coluna: string) {
    if (controle.ordenacao.coluna === coluna) {
      controle.ordenacao.asc = !controle.ordenacao.asc;
    } else {
      controle.ordenacao.coluna = coluna;
      controle.ordenacao.asc = true;
    }
    controle.itens.sort((a, b) => {
      let valA = (a as Record<string, any>)[coluna];
      let valB = (b as Record<string, any>)[coluna];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
      if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
      return 0;
    });
  }
</script>

<template>
  <BreadCrumb PageTitle="Parceiros" />

  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-6 col-md-2">
          <label><i class="flaticon-search"></i> Pesquisar</label>
          <input type="text" class="form-control form-control-sm" placeholder="Nome, código, cnpj..." v-model="controle.filtros.nome" @keyup="pesquisar" />
        </div>

        <div class="col-6 col-md-2">
          <label>Cidade</label>
          <DropdownCidadesAtiva v-model="controle.filtros.cidadeId" @change="pesquisar" />
        </div>

        
        <div class="col-6 col-md-2">
          <label>Vendedor</label>
           <DropdownVendedores v-model="controle.filtros.usuarioId" @change="pesquisar" />
        </div>

        <div class="col-6 col-md-2">
          <label>Voucher</label>
           <select class="form-select form-select-sm" v-model="controle.filtros.voucher" @change="pesquisar">
            <option v-for="(item,idx) in controle.listaVouchers" :value="item.valor" :key="idx">{{ item.descricao }}</option>
          </select>
        </div>

        <div class="col-6 col-md-2">
          <label>Status</label>
           <select class="form-select form-select-sm" v-model="controle.filtros.ativo" @change="pesquisar">
            <option v-for="(item,idx) in controle.listaStatus" :value="item.valor" :key="idx">{{ item.descricao }}</option>
          </select>
        </div>

        <div class="col-6 col-md-2">
          <RouterLink class="btn btn-primary btn-sm mt-4 float-end" :to="'/parceiros/adicionar'"><i class="flaticon-plus"></i> Adicionar</RouterLink>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12 table-responsive">
          <table class="table  align-middle mb-0 table-hover">
            <thead>
              <tr>
                <th @click="ordenarPor('empresaId')" class="th-sortable">Id</th>
                <th>Foto</th>
                <th @click="ordenarPor('nome')" class="th-sortable">Nome</th>
                <th @click="ordenarPor('cnpj')" class="th-sortable">CNPJ</th>
                <th @click="ordenarPor('telefone')" class="th-sortable">Telefone</th>
                <th @click="ordenarPor('celular')" class="th-sortable">Celular</th>
                <th @click="ordenarPor('cidadeId')" class="th-sortable">Cidade</th>
                <th @click="ordenarPor('ativo')" class="th-sortable">Status</th>
                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,idx) in controle.itens" :key="idx" class="align-middle">
                <td>{{item.parceiroId}}</td>
                <td>
                  <img v-if="item.arquivo" :src="item.arquivo" alt="Foto" class="rounded" style="width: 40px; height: 40px; object-fit: cover;" />
                </td>
                <td class="nowrap-celular">
                  {{item.nome}}
                </td>
                <td>{{item.cnpj}}</td>
                <td class="nowrap-celular">{{item.telefone}}</td>
                <td class="nowrap-celular">{{item.celular}}</td>
                <td>{{item.cidade?.nome}}</td>
                <td>
                  <span class="badge rounded-pill" :class="item.ativo ? 'badge-soft-success' : 'badge-soft-danger'">
                    {{ item.ativo ? 'Ativo' : 'Inativo' }}
                  </span>
                </td>
                <td class="text-center text-nowrap">
                  <span>
                    <RouterLink :to="'/parceiros/alterar/' + item.parceiroId">
                        <i class="flaticon-pen fs-5"></i>
                    </RouterLink>

                     <a class="ms-2" href="javascript:void(0);" @click="pergExcluir(item)">
                        <i  class="flaticon-delete fs-5 text-danger" ></i>
                      </a>
                  </span>

                </td>


              </tr>
            </tbody>
          </table>  
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row mt-2">
        <div class="col-md-4">
          {{ controle.totalRegistros }} Registros
        </div>

        <div class="col-md-6">
          <Paginador 
            :paginaAtual="controle.filtros.paginaAtual ?? 1"
            :tamanhoPagina="controle.filtros.tamanhoPagina ?? 20"
            :total-registros="controle.totalRegistros"
            @on-change=" (r) => {
                controle.filtros.paginaAtual = r.paginaAtual;
                controle.filtros.tamanhoPagina = r.tamanhoPagina;
                pesquisar();
            }"/>
        </div>
        
        <div class="col-md-2">
          <RouterLink class="btn btn-secondary btn-sm  float-end" :to="'/'"><i class="flaticon-close"></i> Fechar</RouterLink>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>

.form-control {
  background: #F5F4FA;
}

.th-sortable {
  cursor: pointer;
  user-select: none;
}

a {
  text-decoration: none;
}

/* Evita quebra de linha nas colunas de nome/telefone apenas no celular */
@media (max-width: 767.98px) {
  .nowrap-celular {
    white-space: nowrap;
  }
}
</style>
